import { Alpine } from "./main.alpinejs.js";
import "./main.data.js";

document.getElementsByTagName("html")[0].classList.add("has-js");

Alpine.start();